import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ReactComponent as Mait } from '../assets/pages/Mait_svg.svg';

export const Maitenance = () => {
    return (
        <Box
            style={{
                backgroundColor: '#F2F2F2',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100vh'
            }}>
            <Mait />
            <Typography variant="h6">We are under maintenance</Typography>
            <Typography variant="subtitle1">
                We are currently upgrading our system to make it more useful to you. Thank you for your patience.
            </Typography>
        </Box>
    );
};
